import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';

import { SectionWrapper } from '../components/SectionWrapper';

import zrinkaCoverUrl from '@/images/zrinka_cover.jpg';
import styles from './FacultyStorySection.module.css';

export function FacultyStorySection() {
  return (
    <SectionWrapper background="white" data-testid="faculty-section-ucla-story">
      <div className={styles.layout}>
        <div className={styles.mediaColumn}>
          <img
            alt="Course cover for Professor Stahuljak's literature course, The Uses of Literature."
            className={styles.courseCover}
            loading="lazy"
            src={zrinkaCoverUrl}
          />

          <figure className={styles.quoteCard}>
            <span aria-hidden="true" className={styles.quoteMark} data-accent="amber">
              “
            </span>
            <blockquote className={styles.quote}>
              &quot;Instead of banning AI, this UCLA literature class embraces it.&quot;
            </blockquote>
            <figcaption className={styles.attribution}>
              — LAist, February 2025
            </figcaption>
          </figure>

          <a
            className={styles.externalLink}
            href="https://laist.com/news/education/ucla-humanities-courses-artificial-intelligence-chatgpt-kudu"
            rel="noreferrer"
            target="_blank"
          >
            Visit LAist article <ArrowRight aria-hidden="true" size={14} />
          </a>
        </div>

        <div className={styles.copy}>
          <p className={styles.eyebrow}>A STORY FROM UCLA</p>
          <h2 className={styles.title}>
            Professor Stahuljak&apos;s literature course had no off-the-shelf fit.
          </h2>
          <div className={styles.bodyGroup}>
            <p>
              Decades of primary texts. Primary sources from medieval Latin to
              early modern Italian. A vision for the course no commercial
              textbook came close to. Stahuljak had been teaching the patchwork
              version for years.
            </p>
            <p>
              Kudu turned her materials into a complete AI-enabled course in
              weeks. Faculty review measured in hours. Students, TAs, and
              faculty praised the result. UCLA History has since launched two
              more AI-assisted courses, with three more in the pipeline.
            </p>
            <p>She kept the copyright. No publisher contract.</p>
          </div>
          <Link className={styles.link} to="/press">
            Read more faculty stories <ArrowRight aria-hidden="true" size={16} />
          </Link>
        </div>
      </div>
    </SectionWrapper>
  );
}
